import React from "react";
import { BooleanField, Datagrid, List, TextField } from "react-admin";

const ReviewsList = () => {
  return (
    <List pagination={false}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="text" />
        <BooleanField source="accepted" />
      </Datagrid>
    </List>
  );
};

export default ReviewsList;
